import PropTypes from 'prop-types'
import { HeaderTitle } from '../../../../common/HeaderTitle.jsx'
import { SimpleTable } from '../../../../common/simpleTable/SimpleTable.jsx'
import ButtonWithIcon from '../../../../common/ButtonWithIcon.jsx'
import { Icons } from '../../../../common/Icons.jsx'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { ModalProcesSprawozdania } from '../../../sprawozdania/lib/components/modals.jsx'
import { useListaProcesuSprawozdanie } from "../../../../../api/domain/sprawozdania/queries/useListaProcesuSprawozdanie.jsx";
import {useMeta} from "../../../../../api/domain/elementyRejstru/queries/useMeta.jsx";
import { createTableListaProcesuSprawozdania} from "../../../sprawozdania/lib/columns/tableListaProcesuSprawozdania.jsx";
import {LinkContainer} from "react-router-bootstrap";
import {handleDownloadPdf} from "../../../../utils/handlers/index.js";

const ViewListaProcesuSprawozdania = () => {
    const [currPozycja, setCurrPozycja] = useState({})
    const rola = useSelector((state) => state.user.role)
    const { rejestrId } = useParams()
    const [searchParams] = useSearchParams()
    const selectedSprawozdanieId = searchParams.get('sprawozdanieId')
    const listaPozycji = useListaProcesuSprawozdanie(rejestrId)
    const metaDane = useMeta(rejestrId)
    const isAnulowana = metaDane.data?.item?.status === 'ANULOWANA'
    const listaProcesuRaw = listaPozycji.data?.list || listaPozycji.data || []
    const permissions = useSelector((state) => state.user.permissions)
    const canModifyProcess = Array.isArray(permissions) && permissions.includes('rejestr_obsluga_modyfikacja')

    const getSprawozdanieGroupKey = (item) => {
        if (item?.numer) {
            return String(item.numer).split('-')[0]
        }

        if (item?.json?.rok && item?.json?.kwartal) {
            return `${item.json.rok}-${item.json.kwartal}`
        }
        return null
    }

    const selectedProces = selectedSprawozdanieId
        ? listaProcesuRaw.find((item) => String(item.sprawozdanie_id) === String(selectedSprawozdanieId))
        : null
    const selectedGroupKey = selectedProces ? getSprawozdanieGroupKey(selectedProces) : null

    const procesyZWersja = listaProcesuRaw.filter((p) => p.sprawozdanie_id !== null && p.wersja !== null)

    const latestSprawozdanieId = procesyZWersja.length > 0
        ? Math.max(...procesyZWersja.map((p) => p.sprawozdanie_id))
        : null

    const latestWersja = latestSprawozdanieId
        ? (procesyZWersja.find((p) => p.sprawozdanie_id === latestSprawozdanieId)?.wersja ?? null)
        : null

    const isOldSprawozdanie = !!selectedSprawozdanieId && String(selectedSprawozdanieId) !== String(latestSprawozdanieId)

    const effectiveSprawozdanieId = selectedSprawozdanieId || latestSprawozdanieId
    const effectiveWersja = selectedSprawozdanieId
        ? (procesyZWersja.find((p) => String(p.sprawozdanie_id) === String(selectedSprawozdanieId))?.wersja ?? latestWersja)
        : latestWersja

    const listaProcesu = selectedGroupKey
        ? listaProcesuRaw.filter((item) => getSprawozdanieGroupKey(item) === selectedGroupKey)
        : selectedSprawozdanieId
            ? listaProcesuRaw.filter((item) => String(item.sprawozdanie_id) === String(selectedSprawozdanieId))
        : listaProcesuRaw

    const titleName = `Lista procesu sprawozdania dla projektu o id: ${rejestrId || ''}`
    const [modalState, setModalState] = useState({
        delete: false,
        dodaj: false,
    })
    const openModal = (type, data) => {
        setCurrPozycja(data)
        setModalState((prev) => ({ ...prev, [type]: true }))
    }

    const closeModal = (type) =>
        setModalState((prev) => ({ ...prev, [type]: false }))

    const handleAction = (row, type) => {
        openModal(type, row)
    }

    const allow = {
        show: {
            dodaj: rola === 'oper' && canModifyProcess,
        },
        disabled: {
            dodaj: isAnulowana || isOldSprawozdanie,
        },
    }

    const modals = () => (
        <>
            <ModalProcesSprawozdania
                show={modalState.dodaj}
                handleClose={() => closeModal('dodaj')}
                currPozycja={currPozycja}
            />
        </>
    )

    const th = () => {
        return (
            <>
                <th>Akcje</th>
            </>
        )
    }

    const td = (row) => {
        const sprawozdanieId = row.sprawozdanie_id
        const isZlozony = row.status === 'ZŁOŻONY'
        const kwartal = row?.json?.kwartal || row?.kwartal || '-'

        const allowItem = {
            show: {
                sprawozdanie: isZlozony,
                downloadPdf: isZlozony && !!row.sprawozdanie_id && !!row.wersja,
            },
        }

        return (
            <>
                <td>
                    <div className={'d-flex gap-2'}>
                        {allowItem.show.sprawozdanie && (
                            <LinkContainer
                                to={`/${rola}/sprawozdanie/podglad/${rejestrId}/${sprawozdanieId}`}
                            >
                                <ButtonWithIcon
                                    variant={'secondary'}
                                    onClick={() => handleAction(row, 'view')}
                                    size={'sm'}
                                    icon={<Icons.eye/>}
                                    title='Podgląd sprawozdania'
                                />
                            </LinkContainer>
                        )}

                        {allowItem.show.downloadPdf && (
                            <ButtonWithIcon
                                variant={'secondary'}
                                onClick={() => handleDownloadPdf(
                                    row.sprawozdanie_id,
                                    'pdf',
                                    rola === 'oper' ? 'oper' : '',
                                    row.wersja,
                                    'sprawozdanie'
                                )}
                                size={'sm'}
                                icon={<Icons.download/>}
                                title={`Pobierz PDF (nr: ${row.numer || '-'}, wersja: ${row.wersja || '-'}, kwartał: ${kwartal})`}
                            />
                        )}
                    </div>
                </td>
            </>
        )
    }

    return (
        <>
            {allow.show.dodaj && Object.keys(modalState || {}).some((k) => k) && modals()}
            <HeaderTitle
                breadcrumbLinks={[
                    {label: 'Lista sprawozdań projektu', to: `/${rola}/sprawozdanie/lista/${rejestrId}`},
                    {label: titleName}
                ]}
                home
                nav
                destination={`/${rola}/sprawozdanie/lista/${rejestrId}`}
                size={'fs-3'}
                title={titleName}
            />

            <div className={'d-flex justify-content-end gap-3'}>
                {allow.show.dodaj && (
                    <ButtonWithIcon
                        size={'lg'}
                        onClick={() => handleAction({
                            rejestrId: rejestrId,
                            sprawozdanie_id: effectiveSprawozdanieId,
                            wersja: effectiveWersja,
                            id: null,
                        }, 'dodaj')}
                        text={'Dodaj zdarzenie procesu sprawozdania'}
                        variant={'primary'}
                        icon={<Icons.add />}
                        title={isOldSprawozdanie
                            ? 'Nie można dodać zdarzenia — istnieje nowsze sprawozdanie dla tego projektu'
                            : 'Dodaj zdarzenie procesu sprawozdania'}
                        disabled={allow.disabled.dodaj}
                    />
                )}
            </div>
            <SimpleTable
                detailKey={'oper_profile'}
                columns={createTableListaProcesuSprawozdania()}
                addTh={th}
                addTd={td}
                data={listaProcesu}
                initialSortingColumn={{
                    id: 'id',
                    sort: 'desc',
                }}
            />
        </>
    )
}

ViewListaProcesuSprawozdania.propTypes = {
    moje: PropTypes.bool,
}

export default ViewListaProcesuSprawozdania
